import * as imageApi from '@umu/umu-image-handle';
import { safeJSONParse } from './jsonParse';

let imageCurrentRotate = 0;
function getCurrentRotate(deg: number): number {
    const rotateDeg = (imageCurrentRotate + deg + 360) % 360;
    imageCurrentRotate = rotateDeg;
    return rotateDeg;
}

function getBosUrlRotateSum(url: string, deg: number) {
    const reg1 = /@[^@]*/gi;
    const reg2 = /a_[\-]?[0-9]+/gi;

    if (!reg1.test(url) || !reg2.test(url)) {
        return getCurrentRotate(deg);
    }

    let newDeg = deg;
    const match = url.match(reg2);
    if (match && match.length > 0) {
        newDeg = newDeg + parseInt(match[0].replace('a_', ''), 10);
    }
    return newDeg % 360;
}

function getAwsUrlRotateSum(url: string, deg: number) {
    if (!url || !url.substr) {
        return deg;
    }
    const path = url.substr(url.lastIndexOf('/') + 1);
    try {
        const paramStr = window.atob(path);
        if (!paramStr) {
            return deg;
        }
        try {
            const paramObj = safeJSONParse(paramStr, {}) as any;
            if (!paramObj || !paramObj.edits || !paramObj.edits.rotate) {
                return deg;
            }
            return parseInt(deg + '', 10) + parseInt(paramObj.edits.rotate, 10);
        } catch (parseError) {
            console.error('Failed to parse AWS URL params', parseError, paramStr);
            return deg;
        }
    } catch (error) {
        console.error('Failed to decode AWS URL path', error, path);
        return deg;
    }
}

/**
 * 旋转度数计算
 * 之前的存在的情况：求和,并且360求余数
 */
function rotateImg(url: string, deg: number) {
    let newDeg = deg;
    if (imageApi.isFromAws(url)) {
        newDeg = getAwsUrlRotateSum(url, deg);
    } else {
        newDeg = getBosUrlRotateSum(url, deg);
    }

    return imageApi.rotate(url, newDeg);
}

export { rotateImg, getBosUrlRotateSum, getAwsUrlRotateSum };
